import appConstants from "../../../../../../appConstants";

const gridShortHeaderNamesConfig = {
  pickupNumber: {
    headerName: "Pickup #",
    minWidth: appConstants.columnWidth.W_200,
  },
  shipperState: {
    headerName: "ST",
    minWidth: appConstants.columnWidth.W_70,
  },
  pieces: {
    headerName: "Pcs",
    minWidth: appConstants.columnWidth.W_70,
  },
  weight: {
    headerName: "Wgt",
    minWidth: appConstants.columnWidth.W_85,
  },
  specialInstructions: {
    headerName: "Spec Inst",
    minWidth: appConstants.columnWidth.W_120,
  },
  driverNumber: {
    headerName: "Driver #",
    minWidth: appConstants.columnWidth.W_100,
  },
};

export { gridShortHeaderNamesConfig };
